import React from 'react';
import GLink from 'src/components/GLink';
import HeroSection from 'src/components/global/HeroSection';
import JoinNowSection from 'src/components/global/JoinNowSection';

const BitRageView = () => {
  return (
    <>
      <HeroSection pageTitle="bitRage" uris={['Products', 'bitRage']} />

      <div className="page-content">
        <section data-bg-color="rgba(255, 215, 37, 0.02)">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <iframe title="bitRage" src="https://bitrage.gunthy.org/?type=All" height="600" loading="lazy" />

                <div>
                  <GLink href="#" className="text-body">
                    <i className="bi bi-calendar3 me-1"></i> 3 Nov, 2022
                  </GLink>
                </div>
                <h2 className="my-3">
                  Triangular and Linear Ar<span className="text-gradient fw-700">bitRage</span> for Crypto Exchanges
                </h2>
                <p className="mb-4 lead">
                  Triangular arbitrage is taking advantage of the price of an asset, sold on 2 different markets on the
                  same exchange. Linear arbitrage is taking advantage of the price difference of the same asset on
                  different exchanges. With bitRage we are building both algos. Stay with us.
                </p>

                <div className="mb-4">
                  <h5>How can i access bitRage?</h5>
                  <p className="mb-0">
                    bitRage is not available for public yet, it is a long term experience we are tuning day by day with
                    some hundreds of our beloved beta users. However you can join the beta rooms and participate to the
                    sessions by holding at least 12k tokens. Your resellers will give you more details.
                  </p>
                </div>
                <blockquote
                  className="blockquote border-start border-primary p-5 text-white mb-5"
                  data-bg-color="rgba(30, 80, 255, 0.02)"
                >
                  <p>I can code anything i think about continuosly, like an obsession. I'm obsessed by bitRage.</p>
                  <div className="blockquote-footer text-primary mt-2">Gunthar De Niro</div>
                </blockquote>

                <div className="d-md-flex justify-content-between border-top border-bottom border-dark py-4">
                  <div className="d-flex align-items-center">
                    <h6 className="mb-0 me-4">Share It:</h6>
                    <div className="social-icons">
                      <ul className="list-inline mb-0">
                        <li>
                          <GLink href="#">
                            <i className="bi bi-facebook"></i>
                          </GLink>
                        </li>
                        <li>
                          <GLink href="#">
                            <i className="bi bi-dribbble"></i>
                          </GLink>
                        </li>
                        <li>
                          <GLink href="#">
                            <i className="bi bi-instagram"></i>
                          </GLink>
                        </li>
                        <li>
                          <GLink href="#">
                            <i className="bi bi-twitter"></i>
                          </GLink>
                        </li>
                        <li>
                          <GLink href="#">
                            <i className="bi bi-linkedin"></i>
                          </GLink>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="d-flex align-items-center text-md-end mt-5 mt-md-0">
                    <h6 className="mb-0 me-4">Tags:</h6>
                    <ul className="list-inline mb-0 widget-tags">
                      <li className="list-inline-item">
                        <GLink className="d-inline-block m-1 rounded" href="#">
                          Bitcoin
                        </GLink>
                      </li>
                      <li className="list-inline-item">
                        <GLink className="d-inline-block m-1 rounded" href="#">
                          Arbitrage
                        </GLink>
                      </li>
                      <li className="list-inline-item">
                        <GLink className="d-inline-block m-1 rounded" href="#">
                          Trading
                        </GLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <JoinNowSection />
      </div>
    </>
  );
};

export default BitRageView;
